import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { RCTDeviceEventEmitter, RCTEventEmitter } from "./nativeEmitters";

var SyntheticPlatformEmitter = function () {
  function SyntheticPlatformEmitter() {
    _classCallCheck(this, SyntheticPlatformEmitter);

    this._emitter = new RCTEventEmitter(RCTDeviceEventEmitter.sharedSubscriber);
  }

  _createClass(SyntheticPlatformEmitter, [{
    key: "emit",
    value: function emit(eventName, props) {
      this._emitter.emit(eventName, props);
    }
  }]);

  return SyntheticPlatformEmitter;
}();

export default new SyntheticPlatformEmitter();